/* eslint-disable react/button-has-type */
import { MouseEvent, ReactNode } from 'react';

import clsx from 'clsx';

import classes from './Button.module.css';

export type TButtonVariant =
  | 'PRIMARY'
  | 'SECONDARY'
  | 'ACTION'
  | 'ACTION_SECONDARY'
  | 'OUTLINE'
  | 'OUTLINE_SECONDARY'
  | 'REMOVE';

export type TChildrenProps = {
  defaultTextClass: string;
};

export type TButton = {
  label?: string;
  variant?: TButtonVariant;
  disabled?: boolean;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
  overrideClasses?: {
    root?: string;
    text?: string;
  };
  'data-testid'?: string;
  type?: 'submit' | 'reset' | 'button';
  children?: ReactNode | ((props: TChildrenProps) => ReactNode);
};

export default function Button({
  label = '',
  variant = 'PRIMARY',
  disabled = false,
  onClick = () => {},
  'data-testid': dataTestId,
  type = 'button',
  overrideClasses = {},
  children,
}: TButton) {
  const { root, text } = overrideClasses;

  function getContent() {
    if (!children) {
      return (
        <div
          className={clsx(text, classes.button_text)}
          data-testid="button_text"
        >
          {label}
        </div>
      );
    }

    return typeof children === 'function'
      ? children({ defaultTextClass: classes.button_text })
      : children;
  }

  return (
    <button
      type={type}
      className={clsx(root, classes.button, {
        [classes.primary]: variant === 'PRIMARY',
        [classes.secondary]: variant === 'SECONDARY',
        [classes.outline]: variant === 'OUTLINE',
        [classes.remove]: variant === 'REMOVE',
        [classes.outlineSecondary]: variant === 'OUTLINE_SECONDARY',
        [classes.action]: variant === 'ACTION',
        [classes.action_secondary]: variant === 'ACTION_SECONDARY',
      })}
      disabled={disabled}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {getContent()}
    </button>
  );
}
